import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {Dialog, DialogContent, DialogTitle, Typography, Tooltip} from '@mui/material'
import DialogCancelConfirm from '../DialogCancelConfirm'
import {BulkEditPropertyGroup} from './BulkEditPropertyGroup'
import {BulkEditDialogState} from './BulkEditDialogState'
import {groupIntoArrBy, keyBoardPressActions} from '@oc/utils'
import {makeStyles} from '@oc/styles'

const useStyles = makeStyles({
    dialogPaper: {
        minWidth: '50%',
        maxWidth: '50%',
        minHeight: '90vh',
        maxHeight: '90vh'
    },
    bulkTitle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
})

interface BulkEditDialogProps {
    state: BulkEditDialogState
}

function _BulkEditDialog(props: BulkEditDialogProps) {
    const {state} = props
    const {classes} = useStyles()

    const [selectMenuOpen, shouldBlockCancelConfirmCallback] = React.useState(false)
    const groupedProperties = groupIntoArrBy(state.properties, p => p.groupName)

    return (
        <Dialog
            onKeyDown={event => {
                keyBoardPressActions(
                    event,
                    state.cancel,
                    state.confirm,
                    undefined,
                    !state.canConfirm,
                    state.isOpen && !selectMenuOpen
                )
            }}
            open={state.isOpen}
            fullScreen
            classes={{paper: classes.dialogPaper}}
        >
            <DialogTitle>
                <Tooltip title={state.title}>
                    <Typography className={classes.bulkTitle}>{`${state.title}`}</Typography>
                </Tooltip>
            </DialogTitle>
            <DialogContent>
                {Array.from(groupedProperties.keys())
                    .filter(group => groupedProperties.get(group)?.some(bulkProp => bulkProp.isVisible))
                    .map((group, groupIdx) => (
                        <BulkEditPropertyGroup
                            key={`property-group-${groupIdx}`}
                            groupProperties={groupedProperties.get(group) || []}
                            groupName={group}
                            groupIndex={groupIdx}
                            shouldBlockCancelConfirmCallback={shouldBlockCancelConfirmCallback}
                        />
                    ))}
            </DialogContent>
            <DialogCancelConfirm confirmDisabled={!state.canConfirm} cancel={state.cancel} confirm={state.confirm} />
        </Dialog>
    )
}

export const BulkEditDialog = observer(_BulkEditDialog)
